import { Component, Input, QueryList, ContentChildren, AfterContentInit, Output, EventEmitter } from '@angular/core';
import { ChartJSWidgetComponent } from '../../shared/chart-js/chart-js-widget.component';
import { v4 as uuid4 } from 'uuid';

@Component({
	selector: 'app-site-content-widget',
	templateUrl: './site-content-widget.component.html',
	styleUrls: ['./site-content-widget.component.scss']
})
export class SiteContentWidgetComponent implements AfterContentInit {
    @Input() title : string;
    @Input() briefDescription : string;
    @Input() tooltip : { heading : string, target : string} ;
    @Input() chartTitle : string;
    @Input() showExportButton : boolean = false;
    @Input() data : any;
    
    @Output() ExportDataClick : EventEmitter<any> = new EventEmitter<any>();
    //@Output("?ExportDataClick") ExportDataClick : EventEmitter<any> = new EventEmitter<any>();
    @ContentChildren('chartJSWidget') charts : QueryList<ChartJSWidgetComponent>;

    accordionBodyId : string = "div" + uuid4(); //"div" + new Date().getTime();

    ngAfterContentInit() {
     
    }    
    
    onExportDataClicked = () => {
        this.ExportDataClick && this.ExportDataClick.emit();
    }
}
